export default __webpack_public_path__ + "static/noi2017bronze-9734d191495949cd4c1843331f695296.jpg";